import { FC } from 'react';

import { EmptyState } from '../../../../../../shared';

type Props = {
  description: string;
  title: string;
};

export const SystemMessagesEmptyState: FC<Props> = ({ description, title }) => {
  return <EmptyState description={description} title={title} />;
};
